
<template>
  <v-layout justify-center align-center>
    <v-card min-width="350px" class="mt-10 rounded-xl">
      <v-card-title>
        <span class="headline"> Успешная смена пароля </span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-layout justify-center align-center>
            <v-flex>
              <v-card-text class="subtitle-1">
                Вы успешно сменили пароль!
              </v-card-text>
              <v-card-actions>
                <v-btn
                  color="success"
                  block
                  class="subtitle-1 justify-center"
                  @click="toLogin"
                >
                  Войти
                </v-btn>
              </v-card-actions>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-layout>
</template>


<script>
export default {
  data: () => ({}),
  methods: {
    toLogin: function () {
      this.$router.push({ name: "login" });
    },
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      var token = localStorage.getItem("token");
      if (token) {
        vm.$router.push({ name: "home" });
      }
    });
  },
};
</script>